const n = () => {
  var o;
  return ((o = window.top) == null ? void 0 : o.location.href) || window.location.href;
}, t = (o) => {
  window.top ? window.top.location.href = o : window.location.href = o;
};
export {
  n as getTopWindowHref,
  t as setTopWindowHref
};
